import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NumericFormat } from 'react-number-format';
import { claimActions } from 'store';
import { CustomizedSwitch, FullTable } from 'components';
import { formatNumberToFix, sortListByKey } from 'utils';
import { billingOverviewHead, billingOverviewBody, BILLING_OVERVIEW_ACTION_TYPE, billingOverviewNotYet } from './constants';

export const BillingOverview = () => {
    const dispatch = useDispatch();
    const billingOverviews = useSelector((state) => state.claim.billingOverviews);
    const [allowed, setAllowed] = useState(false);
    const billableAmt = allowed ? billingOverviews?.totalAllowedBillable : billingOverviews?.totalBillable;
    const billableAmtPending = allowed ? billingOverviews?.totalAllowedPending : billingOverviews?.totalPending;
    const billableAmtOpen = allowed ? billingOverviews?.totalAllowedOpen : billingOverviews?.totalOpen;

    useEffect(() => {
        dispatch(claimActions.getBillingOverview());
    }, []);

    return (
        <div>
            <div className="billing-overview-wrapper">
                <div className="switcher-style" style={{ gap: 8 }}>
                    {/*<ToolInfo text={'Require Client/Guardian signature to render this appointment.'} />*/}
                    <CustomizedSwitch checked={allowed} handleClick={() => setAllowed(!allowed)} />
                    <p style={{ margin: 0, color: '#414651', fontWeight: 400 }}>Show allowed amounts</p>
                    {/*<CustomizedSwitch*/}
                    {/*    checked={allowed}*/}
                    {/*    handleClick={() => setAllowed(!allowed)}*/}
                    {/*/>*/}
                </div>

                <div className="billing-overview-box">
                    <div className="billing-overview-price-box">
                        <p>Total Billable:</p>
                        <div>
                            <NumericFormat
                                // value={billableAmt ? billableAmt.toFixed(3) : 0}
                                value={billableAmt ? formatNumberToFix(billableAmt) : 0}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                    <div className="price-line" />
                    <div className="billing-overview-price-box">
                        <p>Total Pending:</p>
                        <div>
                            <NumericFormat
                                // value={billableAmtPending ? billableAmtPending.toFixed(3) : 0}
                                value={billableAmtPending ? formatNumberToFix(billableAmtPending) : 0}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                    <div className="price-line" />
                    <div className="billing-overview-price-box">
                        <p>Total Open Receivables:</p>
                        <div>
                            <NumericFormat
                                // value={billableAmtOpen ? billableAmtOpen.toFixed(3) : 0}
                                value={billableAmtOpen ? formatNumberToFix(billableAmtOpen) : 0}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <FullTable
                head={billingOverviewHead}
                body={billingOverviewBody(allowed)}
                loadingType={BILLING_OVERVIEW_ACTION_TYPE}
                // list={billingOverviews?.list}
                list={sortListByKey(billingOverviews?.list, 'payerName')}
                notYet={billingOverviewNotYet}
                margin={'0'}
                activeRowId={''}
            />
        </div>
    );
};
